<div
    class="modal-background"
    (click)="closeModal()"
    av-data="do-action-before-modal"></div>
<div class="modal-container">
    <div class="modal-title" av-data="do-action-before-modal-tittle">
        {{ input.title }}
    </div>
    <div class="modal-subtitle" av-data="do-action-before-modal-subtitle">
        {{ input.description }}
    </div>

    <div class="modal-close">
        <img src="assets/img/close.svg" (click)="closeModal()" />
    </div>

    <div class="error-message" *ngIf="!loading && error !== undefined">
        {{ error }}
    </div>
    <div class="message-container" *ngIf="input.modalId">
        <input type="checkbox" name="message" [(ngModel)]="dontShowAgain" />
        <label for="message">Don't show this again</label>
    </div>
    <div class="buttons-container">
        <div class="loader" *ngIf="loading"></div>

        <ng-container *ngIf="!loading">
            <div
                class="modal-button modal-text-button cancel-button"
                (click)="closeModal()"
                av-data="do-action-before-modal-cancel">
                Cancel
            </div>

            <div
                class="modal-button modal-blue-button continue-button"
                (click)="continue()"
                *ngIf="input.color === undefined"
                av-data="do-action-before-modal-confirm">
                {{ input.continueButtonText }}
            </div>

            <div
                class="modal-button modal-red-button continue-button"
                (click)="continue()"
                *ngIf="input.color === 'delete'">
                {{ input.continueButtonText }}
            </div>
        </ng-container>
    </div>
</div>
